<template>
    <page>
        <module title="预售活动" enable-flex>
			<m-search ref="search" @search="searchHandle">
			    <m-search-item label="活动名称">
			    	<c-input name="activity_name" placeholder="模糊匹配"></c-input>
			    </m-search-item>
				<m-search-item label="预售类型" style="width:200px">
					<c-checkbox-group name="presell_type" :options="activityType"></c-checkbox-group>
				</m-search-item>
				<m-search-item label="活动状态" style="width:400px">
					<c-checkbox-group name="start_state" :options="activityState"></c-checkbox-group>
				</m-search-item>
			</m-search>
			
			<m-operate>
			    <c-button v-if="auth('b_activity_presell_edit')" color="sys" @click="navigateTo('/activity_presell_add')">新建活动</c-button>
			</m-operate>

            <c-table ref="table">
                <c-table-column
                        label="活动状态"
                        name="start_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>

              <c-table-column
                  label="预售类型"
                  name="presell_type"
                  width="80"
              >
                <template v-slot="{data}">
                  <span v-if="data.presell_type == 1" style="color:dodgerblue">定金</span>
                  <span v-if="data.presell_type == 2" style="color:#999">全款</span>
                </template>
              </c-table-column>

              <c-table-column
                  label="定金比例"
                  width="100"
              >
                <template v-slot="{data}">
                    <span v-if="data.presell_type == 1">
                          {{data.prepayment_ratio}}
                    </span>
                  <span v-else>--</span>
                </template>
              </c-table-column>

              <c-table-column
                  label="活动标签"
                  name="tags"
              ></c-table-column>

              <c-table-column
                        label="活动时间"
                        width="280"
                >
                    <template v-slot="{data}">{{data.begin_date}} - {{data.end_date}}</template>
              </c-table-column>

              <c-table-column
                        label="可付尾款时间"
                        width="280"
                >
                  <template v-slot="{data}">
                    <span v-if="data.presell_type == 1">
                          {{data.balance_begin_date}} - {{data.balance_end_date}}
                    </span>
                    <span v-else>--</span>
                  </template>
              </c-table-column>

              <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                >
              </c-table-column>
              <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="230"
              >
                    <template v-slot="row">
                        <c-table-button v-if="auth('b_activity_presell_view')" @click="navigateTo(`/activity_presell_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="auth('b_activity_presell_edit') && row.data.start_state != 1 && row.data.start_state != 2" @click="navigateTo(`/activity_presell_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button v-if="auth('b_activity_presell_state') && row.data.state == 2 && row.data.start_state != 2" @click="disableActivity(row,1)">暂停</c-table-button>
                        <c-table-button v-if="auth('b_activity_presell_state') && row.data.state == 1 && row.data.start_state != 2" @click="disableActivity(row,2)">开始</c-table-button>
                        <c-table-button v-if="auth('b_activity_presell_edit') && (row.data.start_state == 0 || row.data.start_state == 2 || row.data.start_state == 3)" @click="deleteActivity(row)">删除</c-table-button>
                    </template>
              </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    export default {
        name: 'm_activity_presell',

        data() {
            return {
                activityState: [
                    {name: '未开始',value: 0},
                    {name: '进行中',value: 1},
                    {name: '暂停中',value: 3},
                    {name: '已结束',value: 2}
                ],
                activityType: [
                    {name: '定金',value: 1},
                    {name: '全款',value: 2}
                ]
            }
        },
        computed: {
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('activityPresellList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activityPresell/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
					title: '温馨提示',
                    message: state == 2 ? '确定要开始此预售活动吗？' : '确定要暂停此预售活动吗',
                    resolve: () => {
                        this.request({
                            url: '/activityPresell/updateActivityState',
                            data: {
                                id: item.data.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
									type:'success',
                                    message: state == 2 ? '开始成功' :'暂停成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                this.$confirm({
					title: '温馨提示',
                    message: '确定要删除此预售活动吗？',
                    resolve: () => {
                        this.request({
                            url: '/activityPresell/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
									type:'success',
                                    message: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>